import { createSelector } from 'reselect'

export const selectedAssistance = state => state.assistanceProducts

export const selectSelectedAssistance = createSelector(
  selectedAssistance,
  assistanceProducts => assistanceProducts.selectedAssistance,
)

export const selectAssistanceFormErrors = createSelector(
  selectedAssistance,
    assistanceProducts => assistanceProducts.formErrors
)
